/* eslint-disable react-hooks/exhaustive-deps */
import { TitleSection } from "components/styles";
import BackToView from "components/BackToView/BackToView";
import DialogAlertSuccessRegisterSpace from "./Dialogs/DialogAlertSuccessRegisterSpace/DialogAlertSuccessRegisterSpace";
import DialogAlertConfirmUpdateSpace from "./Dialogs/DialogAlertConfirmUpdateSpace/DialogAlertConfirmUpdateSpace";
import DialogAlertConfirmDeleteSpace from "./Dialogs/DialogAlertConfirmDeleteSpace/DialogAlertConfirmDeleteSpace";
import DialogErrorForFutureReservationsInDeletion from "./Dialogs/DialogErrorForFutureReservationsInDeletion";
import DialogErrorForFutureReservationsInEdition from "./Dialogs/DialogErrorForFutureReservationsInEdition";
import ToggleActiveDialogs from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/ToggleActiveDialogs";
import RegisterSpaceFormFields from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/RegisterSpaceFormFields";
import Footer from "./Footer";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import usePreloadSpace from "./utils/hooks/usePreloadSpace";
import usePreselectedData from "./utils/hooks/usePreselectedData";
import useSpaceChangeHistory from "../../utils/hooks/useSpaceChangeHistory";
import useToggleSpaceActive from "../../utils/hooks/useToggleSpaceActive";
import useSpaceForm from "./utils/hooks/useSpaceForm";
import useSaveChangesForm from "../../utils/hooks/useSaveChangesForm";
import useDeleteSpace from "../../utils/hooks/useDeleteSpace";
import { useNavigate } from "react-router-dom";
import { configSessionStorage } from "services/storage/config";
import { useEffect } from "react";
import { SettingsFormWrapper } from "views/Configuracion/styles";
import { wait } from "utils/others";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { SUCCESS_UPDATE_TOAST_MESSAGE } from "../../utils/constants";

const RegisterSpaceForm = ({
    isUpdate = false, data,
    loadingRequest, toastMessage
}) => {
    const navigate = useNavigate();
    const preselectedData = usePreselectedData({
        isUpdate
    });
    const spaceSelected = usePreloadSpace({
        loadingRequest, isUpdate
    });
    const formHandler = useSpaceForm({
        spaceSelected
    });
    const {
        form, errors
    } = formHandler;
    const dialogSuccessCreate = useShowDialogAlert();
    const deleteSpaceHandler = useDeleteSpace({
        loadingRequest, form,
        onSuccess: () => {
            backToCampusSpaces();
            configSessionStorage.spaceAdmin.spaceId.remove();
        }
    });
    const toggleActiveHandler = useToggleSpaceActive({
        form: formHandler.form,
        loadingRequest, spaceSelected,
        onSuccess: async newActive => {
            spaceSelected.update({ active: newActive });
            await wait(310);
            backToCampusSpaces();
        }
    });
    function backToCampusSpaces() {
        navigate(ABSOLUTE_PATHS.SETTINGS_SPACE_ADMIN_CAMPUS_SPACES);
    }
    const saveChangeHandler = useSaveChangesForm({
        loadingRequest, preselectedData,
        spaceSelected, form,
        onSuccessCreate: () => dialogSuccessCreate.open(),
        onSuccessUpdate: space => {
            toastMessage.show(SUCCESS_UPDATE_TOAST_MESSAGE);
            spaceSelected.update(space);
        }
    });
    useEffect(() => {
        if (spaceSelected.isEmpty()) return;
        form.update(spaceSelected.value);
    }, [spaceSelected.value]);
    const spaceChangeHistory = useSpaceChangeHistory({
        loadingRequest,
        form: form.value
    });
    const getDisabledSaveButton = () => {
        return (
            !form.areThereChanges() ||
            !form.isCompleted() ||
            errors.areThere()
        );
    }
    const {
        dialogConfirmUpdate,
        dialogErrorForFutureReservationsInEdition
    } = saveChangeHandler.dialogs;
    const {
        dialogConfirmDelete,
        dialogErrorForFutureReservationsInDeletion
    } = deleteSpaceHandler.dialogs;
    return (
        <>
            <BackToView to={ABSOLUTE_PATHS.SETTINGS_SPACE_ADMIN_CAMPUS_SPACES} text="Volver al Listado de Espacios" />
            <SettingsFormWrapper>
                <TitleSection>{isUpdate ? "Editar" : "Registrar"} espacio</TitleSection>
                <RegisterSpaceFormFields
                    spaceSelected={spaceSelected}
                    data={data}
                    formHandler={formHandler}
                    toggleActiveHandler={toggleActiveHandler}
                    spaceChangeHistory={spaceChangeHistory} />
                <Footer
                    isUpdate={isUpdate}
                    formHandler={formHandler}
                    openDialogConfirmDelete={dialogConfirmDelete.open}
                    form={form} errors={errors}
                    saveChanges={saveChangeHandler.saveChanges}
                    getDisabledSaveButton={getDisabledSaveButton} />
                <DialogAlertSuccessRegisterSpace
                    dialog={dialogSuccessCreate}
                    backToCampusSpaces={backToCampusSpaces}
                    spaceName={form.value.name} />
                <DialogAlertConfirmUpdateSpace
                    dialog={dialogConfirmUpdate}
                    content={<>Recuerda que podrás visualizar los cambios al ingresar a la opción <b>Editar.</b></>}
                    confirm={saveChangeHandler.updateSpace} />
                <DialogAlertConfirmDeleteSpace
                    dialog={dialogConfirmDelete}
                    confirm={deleteSpaceHandler.deleteSpace} />
                <ToggleActiveDialogs {...toggleActiveHandler} />
                <DialogErrorForFutureReservationsInDeletion
                    dialog={dialogErrorForFutureReservationsInDeletion} />
                <DialogErrorForFutureReservationsInEdition
                    dialog={dialogErrorForFutureReservationsInEdition} />
            </SettingsFormWrapper>
        </>
    );
}

export default RegisterSpaceForm;